export function initGeometryLayers(map) {
  if (map.getSource("final-geometries")) return;

  map.addSource("final-geometries", {
    type: "geojson",
    data: {
      type: "FeatureCollection",
      features: [],
    },
  });

  map.addLayer({
    id: "final-field-fill", type: "fill", source: "final-geometries", 
    paint: {"fill-color": "green", "fill-opacity": 0.3,}, 
    filter: ["==", ["get", "type"], "fieldrectangle"],});

  map.addLayer({
    id: "final-field-lines", type: "line", source: "final-geometries",
    paint: {"line-color": "white", "line-width": 2,},
    filter: ["==", ["get", "type"], "fieldrectangle"],
  });

  map.addLayer({
    id: "final-field-centerline", type: "line", source: "final-geometries",
    paint: {"line-color": "white", "line-width": 2,},
    filter: ["==", ["get", "type"], "fieldcenterline"],
  });
  
  map.addLayer({
    id: "final-mast-lines", type: "line", source: "final-geometries",
    paint: {"line-color": "#ffffff", "line-width": 2, "line-dasharray": [2, 2],},
    filter: ["==", ["get", "type"], "mastsrectangle"],
  });

  map.addLayer({
    id: "final-mast-arrows", type: "line", source: "final-geometries",
    paint: {"line-color": "#000000", "line-width": 2,},
    filter: ["==", ["get", "type"], "mastarrow"],
  });

  map.addLayer({
    id: "final mast-points", type: "circle", source: "final-geometries",
    paint: {"circle-radius": 6, "circle-color": "#ffffff", "circle-stroke-color": "#111827", "circle-stroke-width": 2,},
    filter: ["==", ["get", "type"], "mastpoint"],
  });

  map.addLayer({
    id: "final-building-lines", type: "line", source: "final-geometries", paint: {"line-color": "#FF0000", "line-width": 2,},
    filter: ["==", ["get", "type"], "buildinglines"],
  });
  
}

export function renderGeometries(map, geometries) {
  if (!map.getSource("final-geometries")) return;

  const features = [];

  if (geometries.fieldRectangle) 
    {features.push({type: "Feature", properties: { type: "fieldrectangle" }, geometry: {type: "Polygon", coordinates: [geometries.fieldRectangle],},});}

  if (geometries.mastsRectangle) 
    {features.push({type: "Feature", properties: { type: "mastsrectangle" }, geometry: {type: "Polygon", coordinates: [geometries.mastsRectangle],},});}

  if (geometries.fieldCenterLine) 
    {features.push({type: "Feature", properties: { type: "fieldcenterline" }, geometry: {type: "LineString", coordinates: geometries.fieldCenterLine,},});}

  if (geometries.mastPoints) 
    {geometries.mastPoints.forEach((p) => 
        {features.push({type: "Feature", properties: { type: "mastpoint" }, geometry: {type: "Point", coordinates: p,},});});
    }

  if (geometries.mastArrows) 
    {geometries.mastArrows.forEach((a) => 
        {features.push({type: "Feature", properties: { type: "mastarrow" }, geometry: {type: "LineString", coordinates: a,},});});
    }

  if (geometries.buildingPolylines) 
    {geometries.buildingPolylines.forEach((line) => 
        {features.push({type: "Feature", properties: { type: "buildinglines" }, geometry: {type: "LineString", coordinates: line,},});});
    }

  map.getSource("final-geometries").setData({type: "FeatureCollection", features,});
}